import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc95b092"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "score-view" }
const _hoisted_2 = {
  key: 0,
  class: "score-view__highscore"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Highscore: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: _normalizeClass(["score-view__headline", { flicker: _ctx.newHighscore }])
    }, _toDisplayString(_ctx.newHighscore ? "New Highscore" : "Score"), 3),
    (_ctx.highscore && !_ctx.newHighscore)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.highscore), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", {
      class: _normalizeClass(["score-view__score", [_ctx.scoreClass, _ctx.flickerClass]])
    }, _toDisplayString(_ctx.calculatedScore), 3),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredScoreElements, (scoreElement) => {
        return (_openBlock(), _createElementBlock("p", {
          key: scoreElement.id,
          class: "score-view__score-element"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass([scoreElement.value > 0 ? 'color--green' : 'color--red'])
          }, _toDisplayString(scoreElement.value > 0 ? "+" : "") + _toDisplayString(scoreElement.value), 3),
          _createTextVNode(" " + _toDisplayString(scoreElement.info), 1)
        ]))
      }), 128))
    ])
  ]))
}